import styled, {css} from "styled-components";

interface IButtonSkeletonProps {
    fullWidth?: boolean;
    rounded?: boolean;
    margin?: React.CSSProperties["margin"];
    width: number;
    height: number;
    strokeWidth: number;
    iconOnly: boolean;
    noRemUnits?: boolean;
}

export const ButtonSkeletonBox = styled.div<IButtonSkeletonProps>`
    /**
    * Here i'm just creating a context for the em units to compute relative to this
    */
    font-size: ${props => props.noRemUnits ? "10px" : "1rem"};

    border-radius: ${props => props.rounded ? "100px" : props.theme.layout.border.radius};
    ${props => props.margin ? css`
        margin: ${props.margin};
    ` : null};

    box-sizing: border-box;
    height: ${props => props.height}em;

    width: ${props => {
        if (props.fullWidth) {
            return "100%";
        }
        if (props.iconOnly) {
            return props.height+"em";
        }
        return props.width+"em";
    }};
    
    border-width: ${props => props.strokeWidth}px;
    border-style: solid;


    background: rgba(255, 255, 255, 0.25);
    animation: PulsatingAnimation 1s alternate infinite;
    @keyframes PulsatingAnimation {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0.25;
        }
    }
`;
